/* eslint-disable @reatom/unit-naming-rule */
import { action, atom, filter, readonly, withAssign } from '@reatom/framework'
import BigNumber from 'bignumber.js'

import type { Action, CtxSpy, LensAtom } from '@reatom/framework'

export interface BigNumberAtom extends LensAtom<BigNumber> {
  set: Action<[value: BigNumber.Value], void>
}

export const reatomBigNumber = (value: BigNumber.Value) => {
  const theAtom = atom(BigNumber(value))

  const setAction = action((ctx, value: BigNumber.Value) => {
    const currentValue = ctx.get(theAtom)
    if (currentValue.eq(value)) {
      return
    }
    theAtom(ctx, BigNumber(value))
  })

  return theAtom.pipe(
    readonly,
    withAssign(() => ({
      set: setAction,
    })),
  )
}

export const reatomBigNumberComputed = (
  compute: (ctx: CtxSpy) => BigNumber.Value,
) => {
  const theAtom = atom((ctx) => {
    const computed = compute(ctx)
    return BigNumber.isBigNumber(computed) ? computed : BigNumber(computed)
  })

  return theAtom.pipe(filter((ctx, left, right) => !left.eq(right)))
}
